declare global {
  interface Number {
    formatCurrency(locale: string): string;
    formatNumber(locale: string): string;
  }
}

Number.prototype.formatCurrency = function (this: number, locale: string): string {
  if (locale === 'en-CA') {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      maximumFractionDigits: 0,
      currency: 'CAD',
    }).format(this);
  } else {
    return new Intl.NumberFormat('fr-CA', {
      style: 'currency',
      maximumFractionDigits: 0,
      currency: 'CAD',
    }).format(this);
  }
};

Number.prototype.formatNumber = function (this: number, locale: string): string {
  return new Intl.NumberFormat(locale === 'en-CA' ? 'en-CA' : 'fr-CA', {
    maximumFractionDigits: 0,
  }).format(this);
};
